<template>
  <div>
    <div class="columns is-mobile">
      <div class="column is-half is-offset-one-quarter has-text-left">
        <div class="box has-background-white-ter">
          <h3 class="title has-text-grey-dark">Provide New Password</h3>
          <div class="" style="margin-top:15px;">
            <b-field custom-class="is-size-7 has-text-grey-dark" label="New password"
              :type="{'is-danger': errors.has('password')}"
              :message="errors.first('password')">
              <b-input type="password" v-model="user.new_password1" name="password" v-validate="'required|min:8'"/>
            </b-field>
            <b-field custom-class="is-size-7 has-text-grey-dark" label="Confirm new password"
              :type="{'is-danger': errors.has('confirm-password')}"
              :message="[{
                'The confirm password field is required' : errors.firstByRule('confirm-password', 'required'),
                'The confirm password is not valid' : errors.firstByRule('confirm-password', 'is')
              }]">
              <b-input type="password" v-model="user.new_password2" name="confirm-password"
                v-validate="{ required: true, is: user.new_password1 }" />
            </b-field>
            <div class="columns is-mobile">
              <div class="column">
                <button class="is-pulled-right button is-primary" @click="setNewPassword()">Reset Password</button>
              </div>
            </div>    
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PasswordResetComponent',
  data: function(){
    return {
      user: {}
    }
  },
  methods: {
    setNewPassword: function(){
      this.$validator.validateAll().then(
        (result) => {
          if(result) {
            this.$emit('submitNewPassword', this.user);
          }else {
            this.$toast.open({
              message: 'Form is not valid! Please check the fields',
              type: 'is-danger',
              position: 'is-top'
            })
          }
      })
    }
  }
}
</script>

<style>

</style>
